/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";

export const EventoCaixaSCH = (perPage) => {
  let filtro = new Filtro();
  filtro.perPage = perPage;
  filtro.fields = ['eventos_caixa.descricao', 'eventos_caixa.plano_conta_id', 'tp_evento', 'plano_contas.descricao as plano_conta'];
  filtro.addOrder('eventos_caixa.descricao', 'asc');
  filtro.join.addLeft('plano_contas', 'plano_contas.plano_conta_id', 'eventos_caixa.plano_conta_id');
  return filtro
};
